import React from 'react'
import { BrowserRouter, Route } from 'react-router-dom'
import TokenIndex from './components/TokensIndex'
import Tokens from './components/Tokens'
import Market from './components/Market'
import TokenSale from './components/TokenSale'
import NewToken from './components/NewToken'
import NewSale from './components/NewSale'
import BuyToken from './components/BuyToken'
import GetMetamask from './components/GetMetamask'

console.log(process.env.PUBLIC_URL)

const App = () => (
  <BrowserRouter basename={process.env.PUBLIC_URL}>
    <div>
      <Route path="/" exact component={TokenIndex} />
      <Route path="/tokens/:id" component={Tokens} />
      <Route path='/market' exact component={Market} />
      <Route path='/market/:id' component={TokenSale} />
      <Route path="/newtoken" component={NewToken} />
      <Route path="/newsale" component={NewSale} />
      <Route path="/buytoken/:id" component={BuyToken} />
      <Route path="/getMetamask" component={GetMetamask} />
    </div>
  </BrowserRouter>
)

export default App;
